module.exports = __webpack_public_path__ + "img/create-faq.8affe755.svg";